import makeStore from "../../utils/create-store";
import reducer from "./reducer";

const USER_MODULE_LS_KEY = 'user-module'

export type UserTrackData = {
    id: TrackId,
    answers: SchoolId[],
    status: 'active' | 'completed' | 'lost',
    lastVisited?: NodeId,
}

export type UserModuleState = {
    tracks: UserTrackData[],
    gameStartTime?: number,
    gameEnded: boolean,
    gameEndSended?: boolean
}

const initUserModuleState = {
    tracks: [],
    gameEnded: false
}

export enum USER_MODULE_ACTION {
    CHOOSE_ANSWER,
    SET_LAST_VISITED,

    SET_GAME_TIMER,

    RESET,
    GAME_END,

    RESTART_TRACK,

    END_GAME_SENDED
}

export type UserModuleAction = {
    type: USER_MODULE_ACTION,
    payload?: any
}

const [
    UserModuleProvider,
    useUserModuleDispatch,
    useUserModuleState
] = makeStore(reducer, initUserModuleState, USER_MODULE_LS_KEY)


export {
    UserModuleProvider,
    useUserModuleDispatch,
    useUserModuleState
}
